import { Injectable } from '@angular/core';

export enum NetworkProfile {
  NONE = 'none',
  N3G = 'slow-3g',
  N4G = '4g',
}

export interface NetworkConfig {
  profile: NetworkProfile;
  customDelay?: number;
}

@Injectable({
  providedIn: 'root',
})
export class NetworkThrottleService {
  private config: NetworkConfig = {
    profile: NetworkProfile.NONE,
  };
  private readonly originalFetch: typeof fetch;

  private readonly delays = {
    [NetworkProfile.NONE]: 0,
    [NetworkProfile.N3G]: 3000,
    [NetworkProfile.N4G]: 1000,
  };

  constructor() {
    this.originalFetch = window.fetch.bind(window);
    this.patchFetch();
  }

  private patchFetch(): void {
    console.log('Patching fetch with delay: ', this.getDelayTime(), 'ms');
    window.fetch = async (...args: Parameters<typeof fetch>): Promise<Response> => {
      const delayTime = this.getDelayTime();

      if (delayTime > 0) {
        console.log(`Throttling fetch with delay: ${delayTime}ms`);
        await this.sleep(delayTime);
      }

      return this.originalFetch(...args);
    };
  }

  restoreOriginalFetch(): void {
    window.fetch = this.originalFetch;
  }

  private sleep(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  getDelayTime(): number {
    return this.delays[this.config.profile];
  }

  setProfile(profile: NetworkProfile): void {
    if (profile === NetworkProfile.NONE) {
      this.disable();
      return;
    }

    this.config.profile = profile;
    this.patchFetch();
  }

  disable(): void {
    this.restoreOriginalFetch();
    this.config.profile = NetworkProfile.NONE;
  }
}
